module.exports = __webpack_public_path__ + "img/sshx3.0f5a11cf.png";